import { consoleInfo } from './lib/_tool.js';
import { loc } from './lib/_location.js';
import { viewTransition } from './page/_viewTransition.js';
import { pages } from './page/_pushstate.js';


export class Framework {
	constructor(){
		this.pageinfo = loc.all();
		this.changeContent();
		consoleInfo("URL Info:", this.pageinfo);
	}
	
	changeContent(){
		this.afterChangePage();
	}
	
	afterChangePage(){
		//get page info
		this.pageinfo = loc.all();
		pages.init();
		
		//viewTransition.init();
	}
}